import { takeLatest } from 'redux-saga/effects'
import abstractDuck from '../helpers/singleActionDuck'

// The resident page's initial forms notice. Its own slice: the Health tab resets
// healthReviewsListTimeline when it unmounts, and the notice stays on the page across tabs.
const apiUrl = `${process.env.REACT_APP_API_URL}/health-reviews`
const name = 'healthReviewsInitialForms'
const { types, actions, sagas, selectors, reducers } = abstractDuck({ name, apiUrl, method: 'GET' })

export const slice = {
  types,
  actions,
  sagas: [takeLatest(types.ACTION, sagas[name])],
  selectors
}

export default reducers
